export default {
      id: "huge-warning-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "img/icons.0b648a3c.svg#huge-warning",
      toString: function () {
        return this.url;
      }
    }